import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumDataConnector({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M567.922 123.946C567.922 134.962 533.689 143.893 491.461 143.893C449.233 143.893 415 134.962 415 123.946C415 112.93 449.233 104 491.461 104C533.689 104 567.922 112.93 567.922 123.946Z"
        fill="white"
      />
      <path
        d="M567.922 163.839L567.916 164.096C567.388 174.994 533.36 183.785 491.461 183.785C449.233 183.785 415 174.855 415 163.839V137.244C415 148.26 449.233 157.19 491.461 157.19C533.359 157.19 567.387 148.399 567.916 137.502L567.922 137.244V163.839Z"
        fill="white"
      />
      <path
        d="M567.922 203.731L567.916 203.989C567.388 214.886 533.36 223.677 491.461 223.677C449.233 223.677 415 214.747 415 203.731V177.136C415 188.152 449.233 197.082 491.461 197.082C533.359 197.082 567.387 188.291 567.916 177.394L567.922 177.136V203.731Z"
        fill="#57D7D9"
      />
      <path
        d="M567.922 243.623L567.916 243.881C567.388 254.778 533.36 263.57 491.461 263.57C449.233 263.57 415 254.639 415 243.623V217.029C415 228.045 449.233 236.975 491.461 236.975C533.359 236.975 567.387 228.184 567.916 217.286L567.922 217.029V243.623Z"
        fill="white"
      />
      <path
        d="M265.5 430C265.754 430 266.006 430.013 266.256 430.03C266.502 430.012 266.75 430 267 430C272.523 430 277 434.477 277 440V492C277 497.523 272.523 502 267 502C261.477 502 257 497.523 257 492V451H207V492C207 497.523 202.523 502 197 502C191.477 502 187 497.523 187 492V451H137V492C137 497.523 132.523 502 127 502C121.477 502 117 497.523 117 492V440C117 434.477 121.477 430 127 430C127.249 430 127.496 430.011 127.74 430.029C127.991 430.011 128.244 430 128.5 430H265.5Z"
        fill="white"
      />
      <path
        d="M290 556C290 562.627 284.627 568 278 568H256C249.373 568 244 562.627 244 556V526C244 519.373 249.373 514 256 514H278C284.627 514 290 519.373 290 526V556Z"
        fill="white"
      />
      <path
        d="M220 556C220 562.627 214.627 568 208 568H186C179.373 568 174 562.627 174 556V526C174 519.373 179.373 514 186 514H208C214.627 514 220 519.373 220 526V556Z"
        fill="#57D7D9"
      />
      <path
        d="M150 556C150 562.627 144.627 568 138 568H116C109.373 568 104 562.627 104 556V526C104 519.373 109.373 514 116 514H138C144.627 514 150 519.373 150 526V556Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M381.051 271.06C383.151 269.169 386.386 269.339 388.276 271.439L405.393 290.448C407.284 292.548 407.114 295.783 405.014 297.674L395.598 306.152C400.647 316.315 402.914 327.457 402.454 338.48L414.521 342.4C417.208 343.274 418.679 346.16 417.806 348.847L409.901 373.175C409.028 375.862 406.142 377.333 403.455 376.46L391.404 372.544C388.381 377.084 384.746 381.324 380.506 385.141C376.266 388.959 371.67 392.13 366.839 394.662L369.474 407.056C370.061 409.82 368.297 412.537 365.533 413.124L340.512 418.443C337.748 419.03 335.032 417.266 334.444 414.502L331.806 402.092C320.796 401.396 309.952 397.978 300.372 391.894L290.956 400.372C288.856 402.263 285.622 402.093 283.731 399.993L266.614 380.984C264.724 378.884 264.893 375.649 266.993 373.759L276.409 365.28C271.36 355.117 269.094 343.975 269.553 332.952L257.486 329.032C254.799 328.159 253.328 325.272 254.201 322.585L262.106 298.257C262.979 295.57 265.865 294.099 268.553 294.972L280.604 298.888C283.627 294.348 287.261 290.109 291.501 286.291C295.741 282.473 300.337 279.302 305.168 276.77L302.534 264.376C301.946 261.612 303.711 258.895 306.474 258.308L331.495 252.989C334.259 252.402 336.976 254.166 337.563 256.93L340.201 269.341C351.212 270.036 362.055 273.454 371.635 279.538L381.051 271.06ZM316.994 352.833C326.447 363.331 342.621 364.179 353.12 354.726C363.619 345.273 364.467 329.098 355.013 318.6C345.56 308.101 329.386 307.253 318.887 316.706C308.389 326.16 307.541 342.334 316.994 352.833Z"
        fill="#57D7D9"
      />
      <path
        d="M344.717 205.071L384.978 181.632C388.116 179.805 389.179 175.78 387.352 172.642L363.913 132.382C360.966 127.32 353.37 128.348 351.874 134.011L342.635 169L335.053 197.71C333.557 203.374 339.655 208.018 344.717 205.071Z"
        fill="white"
      />
      <path
        d="M161.26 291.028C167.601 264.246 180.18 239.341 197.97 218.342C215.76 197.342 238.259 180.842 263.635 170.187C289.01 159.531 318.354 154.998 345.803 157L342.635 169L339.5 180.87C315.821 179.142 294.817 183.123 272.927 192.315C251.037 201.507 231.628 215.741 216.282 233.855C200.935 251.97 190.085 273.454 184.615 296.557C179.145 319.66 179.21 343.729 184.805 366.802C186.367 373.242 182.412 379.73 175.971 381.292C169.531 382.854 163.044 378.898 161.482 372.457C154.996 345.71 154.92 317.81 161.26 291.028Z"
        fill="white"
      />
      <path
        d="M350.118 464.113L321.211 500.646C318.958 503.494 319.44 507.629 322.287 509.882L358.821 538.789C363.414 542.423 370.109 538.69 369.431 532.872L361.804 467.431C361.126 461.613 353.752 459.52 350.118 464.113Z"
        fill="white"
      />
      <path
        d="M512.621 366.413C508.932 390.841 500.104 414.208 486.72 434.974C473.336 455.74 455.701 473.431 434.978 486.88C414.255 500.33 391.531 509.233 367.115 513L365.749 501.28L364.318 489C385.38 485.75 404.036 478.351 421.913 466.749C439.789 455.147 455.001 439.886 466.546 421.972C478.092 404.059 485.707 383.901 488.89 362.829C492.073 341.756 490.75 320.248 485.01 299.725C483.225 293.342 486.952 286.721 493.334 284.936C499.717 283.151 506.338 286.878 508.123 293.26C514.777 317.052 516.31 341.985 512.621 366.413Z"
        fill="white"
      />
    </svg>
  );
}
